import services from "../services";

import find from "lodash/find";
import findIndex from "lodash/findIndex";
import map from "lodash/map";
import remove from "lodash/remove";
import filter from "lodash/filter";
import isEmpty from "lodash/isEmpty";
import orderBy from "lodash/orderBy";
import Utils from "../Utils";
import forEach from "lodash/forEach";

const strict = true;
const SORT_BY = "asc";

const getDefaultState = () => {
  return {
    toSearch: "",
    multiSelectConfig: {
      items: [],
      activeItems: []
    },
    sortConfig: {
      list: ["A-Z", "Z-A"],
      order: "A-Z"
    },
    filterCriteriaResults: "",
    dimension: {
      initial: {},
      edited: {}
    },
    doctorServiceFullList: [],
    doctorServiceList: [],
    serviceList: [],
    doctorTimeTableList: [],
    doctorVacationList: []
  };
};
const state = getDefaultState();

const getters = {
  items: state => state.doctorServiceList,
  toSearch: state => state.toSearch,
  multiSelectFullList: state => state.multiSelectConfig.items,
  multiSelectActiveList: state => state.multiSelectConfig.activeItems,
  orderList: state => state.sortConfig.list,
  order: state => state.sortConfig.order,
  totalItems: state => state.doctorServiceList.length,
  filterCriteriaResults: state => state.filterCriteriaResults,
  activeSortValue: state => `Cognome (${state.sortConfig.order})`,
  editedDimension: state => {
    return state.dimension.edited;
  },
  getDoctorById: state => id => {
    return state.doctorServiceList.find(doctor => doctor.doctorId == id);
  },
  doctorServiceList: state => {
    return state.doctorServiceList;
  },
  doctorServiceListWithId: state => doctorId => {
    return find(state.doctorServiceList, doctorService => {
      return doctorService.doctorId === doctorId;
    });
  },
  serviceList: state => state.serviceList,

  doctorTimeTableList: state => {
    return state.doctorTimeTableList;
  },
  doctorTimeTableListWithId: state => doctorId => {
    return find(state.doctorTimeTableList, doctorTimeTable => {
      return doctorTimeTable.doctor.id === doctorId;
    });
  },
  doctorVacationList: state => {
    return state.doctorVacationList;
  }
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_TO_SEARCH(state, toSearch) {
    state.toSearch = toSearch;
  },
  SET_MULTI_SELECT_ACTIVE_LIST(state, multiSelectList) {
    state.multiSelectConfig.activeItems = multiSelectList;
  },
  SET_MULTI_SELECT_FULL_LIST(state, multiSelectFullList) {
    state.multiSelectConfig.items = map(multiSelectFullList, service => {
      return service.nameByLang;
    });
  },
  SET_ORDER(state, order) {
    state.sortConfig.order = order;
  },
  SET_FILTER_CRITERIA_RESULTS(state) {
    let criteria = [];
    if (state.toSearch) {
      criteria.push("'" + state.toSearch + "'");
    }

    if (!isEmpty(state.multiSelectConfig.activeItems)) {
      criteria.push("'" + state.multiSelectConfig.activeItems.join(", ") + "'");
    }

    state.filterCriteriaResults = criteria.join(" & ");
  },
  SET_INITIAL_DIMENSION(state, dimension) {
    state.dimension.initial = dimension;
  },
  SET_MODIFIED_DIMENSION(state, dimension) {
    state.dimension.edited = dimension;
  },
  RESET_MODIFIED_DIMENSION(state) {
    state.dimension.edited = {
      ...state.dimension.initial
    };
  },
  SET_DOCTOR_SERVICE_FULL_LIST(state, doctorServiceFullList) {
    forEach(doctorServiceFullList, doctorServiceItem => {
      doctorServiceItem.serviceList = orderBy(
        doctorServiceItem.serviceList,
        service => service.nameByLang.toLowerCase(),
        SORT_BY
      );
    });
    state.doctorServiceFullList = doctorServiceFullList;
  },
  SET_DOCTOR_SERVICE_LIST(state, doctorServiceList) {
    state.doctorServiceList = doctorServiceList;
  },
  addDoctor(state, { doctorId, doctor }) {
    state.doctorServiceFullList.unshift({
      doctor: doctor,
      doctorId: doctorId,
      serviceList: []
    });
  },
  updateDoctor(state, { doctorId, doctor }) {
    let doctorServiceIndex = findIndex(
      state.doctorServiceFullList,
      curDoctorService => {
        return curDoctorService.doctorId === doctorId;
      }
    );
    state.doctorServiceFullList[doctorServiceIndex].doctor = doctor;
  },
  deleteDoctor(state, doctorId) {
    remove(state.doctorServiceFullList, curDoctorService => {
      return curDoctorService.doctorId == doctorId.doctorId;
    });
  },
  updateDoctorService(state, { doctorId, serviceId, service }) {
    let doctorServiceIndex = findIndex(
      state.doctorServiceFullList,
      curDoctorService => {
        return curDoctorService.doctorId === doctorId;
      }
    );

    let serviceIndex = findIndex(
      state.doctorServiceFullList[doctorServiceIndex].serviceList,
      curService => {
        return curService.serviceId === serviceId;
      }
    );

    if (serviceIndex === -1) {
      state.doctorServiceFullList[doctorServiceIndex].serviceList.push(service);
    }
  },
  deleteDoctorService(state, { doctorId, serviceId }) {
    let doctorServiceIndex = findIndex(
      state.doctorServiceFullList,
      curDoctorService => {
        return curDoctorService.doctorId === doctorId;
      }
    );

    remove(
      state.doctorServiceFullList[doctorServiceIndex].serviceList,
      curService => {
        return curService.serviceId === serviceId;
      }
    );
  },
  SET_SERVICE_LIST(state, serviceList) {
    state.serviceList = serviceList;
  },
  addDoctorTimeTable(state, doctor) {
    state.doctorTimeTableList.push(doctor);
  },
  updateDoctorTimeTable(state, doctorTimeTable) {
    let doctorTimeTableIndex = findIndex(
      state.doctorTimeTableList,
      curDoctorTimeTable => {
        return curDoctorTimeTable.doctor.id === doctorTimeTable.doctor.id;
      }
    );

    if (doctorTimeTableIndex !== -1) {
      state.doctorTimeTableList[doctorTimeTableIndex] = doctorTimeTable;
    } else {
      state.doctorTimeTableList.push(doctorTimeTable);
    }
  },
  doctorVacationList(state, doctorVacationList) {
    state.doctorVacationList = doctorVacationList;
  },
  addDoctorVacations(state, doctor) {
    state.doctorVacationList.push(doctor);
  }
};

const actions = {
  fetchDimension({ commit }, officeId) {
    commit("loading/OPEN_LOADING_DIALOG", null, {
      root: true
    });
    return services.hfManagementService
      .fetchDimension(officeId)
      .then(dimension => {
        commit("SET_INITIAL_DIMENSION", dimension);
        commit("SET_MODIFIED_DIMENSION", dimension);
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject();
      })
      .finally(() => {
        commit("loading/CLOSE_LOADING_DIALOG", null, {
          root: true
        });
      });
  },
  setDimension({ commit }, { officeId, dimension }) {
    return services.hfManagementService
      .updateDimension(officeId, dimension)
      .then(() => {
        commit("SET_INITIAL_DIMENSION", dimension);
        commit("SET_MODIFIED_DIMENSION", dimension);
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject();
      })
      .finally(() => {});
  },
  fetchDoctorServiceList({ commit, dispatch }, officeId) {
    commit("loading/OPEN_LOADING_DIALOG", null, {
      root: true
    });
    return services.hfManagementService
      .fetchDoctorServiceList(officeId)
      .then(doctorServiceList => {
        commit("SET_DOCTOR_SERVICE_LIST", doctorServiceList);
        commit("SET_DOCTOR_SERVICE_FULL_LIST", doctorServiceList);

        dispatch("getItems");
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject();
      })
      .finally(() => {
        commit("SET_FILTER_CRITERIA_RESULTS");
        commit("loading/CLOSE_LOADING_DIALOG", null, {
          root: true
        });
      });
  },
  getItems({ commit, state }) {
    return filterDoctorServiceListPromise(
      state.doctorServiceFullList,
      state.toSearch,
      state.multiSelectConfig.activeItems
    )
      .then(doctorServiceList => {
        if (doctorServiceList.length)
          return sortDoctorServiceList(
            doctorServiceList,
            state.sortConfig.order
          );
        else return doctorServiceList;
      })
      .then(doctorServiceList => {
        commit("SET_DOCTOR_SERVICE_LIST", doctorServiceList);
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {
        commit("SET_FILTER_CRITERIA_RESULTS");
        let doctorListElement = document.querySelector(
          ".doctor-list-container"
        );
        if (doctorListElement) {
          doctorListElement.scrollTo({
            top: 0,
            behavior: "auto"
          });
        }
      });
  },
  addDoctor({ commit }, { officeId, newDoctor }) {
    return services.hfManagementService
      .addDoctor(officeId, newDoctor)
      .then(doctorId => {
        return doctorId;
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject();
      })
      .finally(() => {});
  },
  updateDoctor({ commit }, { officeId, doctorId, doctor }) {
    return services.hfManagementService
      .updateDoctor(officeId, doctorId, doctor)
      .then(response => {
        return response.doctorId;
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject();
      })
      .finally(() => {});
  },
  deleteDoctor({ commit }, doctorId) {
    return services.hfManagementService
      .deleteDoctor(doctorId)
      .then(() => {})
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
        return Promise.reject();
      })
      .finally(() => {});
  },
  updateDoctorService({ commit }, { doctorService, service }) {
    return services.hfManagementService
      .updateDoctorService(doctorService)
      .then(() => {})
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  deleteDoctorService({ commit }, { doctorService }) {
    return services.hfManagementService
      .deleteDoctorService(doctorService)
      .then(() => {})
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  fetchServiceList({ commit }, officeId) {
    commit("loading/OPEN_LOADING_DIALOG", null, {
      root: true
    });
    const macroArea = "VSP";
    return services.hfManagementService
      .fetchHFServices(officeId)
      .then(serviceListWithAllFields => {
        let filteredServiceList = filter(serviceListWithAllFields, {
          macroArea: macroArea
        });
        let serviceList = map(filteredServiceList, service => {
          return {
            serviceId: service.serviceId,
            nameByLang: service.label
              ? service.label.defaultValue
              : "NO_DESCRIPTION_AVAILABLE"
          };
        });
        return orderBy(
          serviceList,
          service => service.nameByLang.toLowerCase(),
          SORT_BY
        );
      })
      .then(serviceList => {
        commit("SET_SERVICE_LIST", serviceList);
        commit("SET_MULTI_SELECT_FULL_LIST", serviceList);
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }
        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {
        commit("loading/CLOSE_LOADING_DIALOG", null, {
          root: true
        });
      });
  },
  addNewDoctorTimeTable({ commit }, { newDoctorTimeTable }) {
    return services.hfManagementService
      .addNewDoctorTimeTable(newDoctorTimeTable)
      .then(doctorTimeTable => {
        commit("addDoctorTimeTable", doctorTimeTable);
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  // TODO getDoctorTimeTable
  updateDoctorTimeTable({ commit }, { newDoctorTimeTable }) {
    return services.hfManagementService
      .addNewDoctorTimeTable(newDoctorTimeTable)
      .then(doctorTimeTable => {
        commit("updateDoctorTimeTable", doctorTimeTable);
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  addNewDoctorVacations({ commit }, { newDoctorVacations }) {
    return services.hfManagementService
      .addNewDoctorVacations(newDoctorVacations)
      .then(doctorVacations => {
        commit("addDoctorVacations", doctorVacations);
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "hfManagement";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  async exportOfficeStaffExcelFile(
    { commit, state },
    { officeId, officeName }
  ) {
    try {
      let officeDoctorIds = "";
      if (state.doctorServiceList.length < state.doctorServiceFullList.length) {
        officeDoctorIds = state.doctorServiceList
          .map(doctorServiceItem => doctorServiceItem.doctorId)
          .join(",");
      }
      const { data } =
        await services.hfManagementService.generateOfficeDoctorsExcelFile(
          officeId,
          officeDoctorIds
        );
      Utils.downloadBlob(
        data,
        `Medici della struttura ${Utils.sanitizeFileName(officeName)}.xlsx`,
        data?.type || XLSX_MIME
      );
    } catch (reason) {
      commit("error/SET_ERROR", Utils.toErrorPayload(reason), { root: true });
      throw reason;
    }
  }
};

function filterDoctorServiceListPromise(
  doctorServiceList,
  toSearch,
  toServiceFilter
) {
  return new Promise((resolve, reject) => {
    try {
      const searchList = toSearch ? toSearch.toLowerCase().split(" ") : [];
      let filteredList = doctorServiceList.filter(doctorServiceItem => {
        let q1List = doctorServiceItem.doctor.name.toLowerCase().split(" ");
        let q2List = doctorServiceItem.doctor.surname.toLowerCase().split(" ");
        let queries = q1List.concat(q2List);
        let newMatch =
          searchList.length == 0
            ? true
            : searchList.every(item => queries.includes(item));
        let serviceList = map(doctorServiceItem.serviceList, "nameByLang");
        let hasService =
          toServiceFilter.length === 0
            ? true
            : toServiceFilter.some(i => serviceList.indexOf(i) >= 0);
        return newMatch && hasService;
      });
      resolve(filteredList);
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
}

function sortDoctorServiceList(doctorServiceList, order) {
  const sortBy = order == "A-Z" ? "asc" : "desc";
  return orderBy(
    doctorServiceList,
    doctorServiceItem => doctorServiceItem.doctor.surname.toLowerCase(),
    sortBy
  );
}

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
